/* eslint-disable no-useless-escape */
import { beAsyncTaskGetTaskDetails } from 'Api/beAsyncTaskApi'
import {
  beAutomatioApiPostSaveTask,
  beAutomatioApiPutUpdateTask,
  beAutomatioGetTask,
  beAutomationApiSetTaskEnable,
  beAutomationApiSimulate
} from 'Api/beAutomationApi'
import {
  beEmailMessageApiGetMessageDetailsLazy,
  beEmailMessageSearchMessages,
  beEmalMessagelistRssFeedByIdList
} from 'Api/beEmailMessageApi'
import {
  beFiltersGetListOfCategories,
  beFiltersGetListOfFilters,
  getAllAvailableFilterTypes
} from 'Api/beFiltersApi'
import {
  beListAddNewTag,
  beListApiGetAllTags,
  beListGetList
} from 'Api/beListApi'
import {
  beMessApiCopyMessage,
  beMessApiGetEntitiesThatUseMessage
} from 'Api/beMessApi'
import { bePecPlusGetPecPlusConfig } from 'Api/bePecPlusApi'
import {
  beRecipientAddGroup,
  beRecipientGetDynamicFieldsDefinition,
  beRecipientGetGroupById
} from 'Api/beRecipientApi'
import {
  beSendGetSenderStatus,
  TRUSTED_SENDER_STATUS_NOT_CONFIRMED
} from 'Api/beSendApi'

import {
  beSmsMessageCopyMessage,
  beSmsMessageGetEntitiesThatUseMessage,
  beSmsMessageGetMessages,
  beSmsMessGetMessageMinimumDetails
} from 'Api/beSmsMessageApi'
import { beSMSSendGetSenderStatus } from 'Api/beSMSSendApi'
import { LOGIN_TYPE_ADM, LOGIN_TYPE_ADMLIMITED } from 'Constants/'

import getIntl from 'Helpers/intl'
import {
  STORE_KEY_ID_LIST,
  STORE_KEY_LOGIN_TYPE,
  storeGet
} from 'mailup-react-helpers'
import { TOAST_VARIANT_ERROR, toastShow } from 'mailup-web-components'

export async function getTaskAction(idTask) {
  const result = await beAutomatioGetTask(idTask)
  return result
}

export async function getAllTags() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  const result = await beListApiGetAllTags(idList)
  return result
}

export async function addNewTag(pTagName) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beListAddNewTag(idList, pTagName)
  return result
}

export async function fetchDynamicFieldsAction() {
  const result = await beRecipientGetDynamicFieldsDefinition()

  return {
    dynamicFields: result.map(({ Id, Description }) => ({
      value: Id,
      label: `${Id} - ${Description}`
    }))
  }
}
export async function addGroup(name, notes, test) {
  const IdList = storeGet(STORE_KEY_ID_LIST)
  const payload = {
    IdList,
    Name: name,
    Notes: notes,
    Deleteable: true,
    Type: test ? 'Test' : 'Normal'
  }
  const newGroup = await beRecipientAddGroup(payload)
  return newGroup
}
export async function getMessagesList(searchString) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const { Items } = await beEmailMessageSearchMessages(
    idList,
    {
      pageNumber: 1,
      pageSize: 0,
      orderBy: 'Id',
      orderDescending: false
    },
    {
      SearchText: '',
      SearchAdvanced: false,
      Tags: [],
      Status: 'Published',
      ConditionDate: 1,
      StartDate: '',
      EndDate: '',
      ServiceTypes: [0, 3],
      MessageType: ['Generic', 'Welcome', 'Confirmation']
    }
  )

  return {
    emailMessages: Items.map(({ Id, Subject, IsBee }) => ({
      value: Id,
      label: `${Id} - ${Subject}`,
      isBee: IsBee
    }))
  }
}

export async function getSmsList() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beSmsMessageGetMessages(
    idList,
    {
      pageNumber: 1,
      pageSize: 0,
      orderBy: 'Id',
      orderDescending: false
    },
    {}
  )

  return {
    smsMessages: Items.map(({ Id, Subject, IsBee }) => ({
      value: Id,
      label: `${Id} - ${Subject}`
    }))
  }
}

export async function getListAction() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  return await beListGetList(idList)
}

export async function getPecPlusConfigAction() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  return await bePecPlusGetPecPlusConfig(idList)
}

export async function fetchMessageDetailsById(idMessage) {
  const result = await beEmailMessageApiGetMessageDetailsLazy(idMessage)
  return result
}

export async function getListOfFiltersAction(params) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beFiltersGetListOfFilters(idList, params)
  return result
}

export async function getFilters() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const hidden =
    loginType !== LOGIN_TYPE_ADM && loginType !== LOGIN_TYPE_ADMLIMITED
      ? false
      : undefined

  const categories = await beFiltersGetListOfCategories({
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false
  })

  const allCategories = [
    {
      Id: 0,
      Name: getIntl().formatMessage({ id: 'Load.Filters.WithoutCategory' })
    },
    ...categories.Items
  ]

  const allFilters = (
    await beFiltersGetListOfFilters(idList, {
      pageSize: 0,
      pageNumber: 1,
      orderBy: 'Name',
      orderDescending: false,
      hidden,
      types: getAllAvailableFilterTypes()
    })
  ).Items

  const result = {
    optionGroups: allCategories
      .map(({ Id, Name }) => ({
        id: Id,
        label: Name,
        values: allFilters
          .filter(({ Category }) => Category === Id)
          .map(({ Id }) => Id)
      }))
      .filter(({ values }) => values.length > 0),
    options: allFilters.map(({ Id, Name, Type, Description }) => ({
      label: `${Id} - ${Name}`,
      value: Id,
      type: Type,
      description: Description,
      name: Name
    }))
  }

  return result
}

export async function fetchEmailEntitiesThatUseMessage(idMessage) {
  const ret = await beMessApiGetEntitiesThatUseMessage(idMessage)
  return ret
}

export async function fetchSmsEntitiesThatUseMessage(idMessage) {
  const ret = await beSmsMessageGetEntitiesThatUseMessage(idMessage)
  return ret
}

export async function copyMessage(idMessage, notes) {
  const result = await beMessApiCopyMessage(idMessage, notes)

  return result
}

export async function copySmsMessage(idMessage, notes) {
  const result = await beSmsMessageCopyMessage(idMessage, notes, '', '')

  return result
}

export async function listRssFeedByIdListAction(params) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beEmalMessagelistRssFeedByIdList(idList, params)
  return result
}

export async function getMessageMinimumDetailsAction(idMessage) {
  return beSmsMessGetMessageMinimumDetails(idMessage)
}

export async function getGroupByIdAction(id) {
  return beRecipientGetGroupById(id)
}

export async function saveTask(params) {
  const result = await beAutomatioApiPostSaveTask(params)
  return result
}
export async function updateTask(idTask, params) {
  const prev = await beAutomatioGetTask(idTask)

  const result = await beAutomatioApiPutUpdateTask(idTask, {
    ...prev,
    ...params,
    Detail: {
      ...prev.Detail,
      ...params.Detail
    }
  })

  return result
}

export async function setTaskEnable(idTask, params) {
  const result = beAutomationApiSetTaskEnable(idTask, params)
  return result
}

export async function senderEmailStatus(email) {
  const result = await beSendGetSenderStatus(email)
  return result !== null ? result.Status : TRUSTED_SENDER_STATUS_NOT_CONFIRMED
}

export async function senderSmsStatus(SenderNumber) {
  const result = await beSMSSendGetSenderStatus(SenderNumber)

  return result !== null ? result.Status : TRUSTED_SENDER_STATUS_NOT_CONFIRMED
}

function isEmpty(str) {
  return str == null || str.trim() === ''
}

function isEmptyArray(arr) {
  return arr == null || arr.length === 0
}

function fieldFilterNeedsValue(idFieldFilter) {
  return (
    idFieldFilter !== 13 &&
    idFieldFilter !== 14 &&
    idFieldFilter !== 15 &&
    idFieldFilter !== 16 &&
    idFieldFilter !== 20 &&
    idFieldFilter !== 28 &&
    idFieldFilter !== 29
  )
}

function fieldFilterValueOk(fieldType, idFieldFilter, fieldValue) {
  let fieldOk = false

  // Se non   di tipo carattere...
  if (fieldType !== 3) fieldValue = fieldValue.trim()

  if (fieldFilterNeedsValue(idFieldFilter)) {
    let re = null

    if (fieldType === 1) {
      // Intero
      re = /^[+-]?\d+$/
    } else if (fieldType === 2) {
      // Decimale
      re = /^[+-]?\d+([.,]\d+)?$/
    } else if (fieldType === 3) {
      // Carattere
      re = /.*/
    } else if (fieldType >= 5 && fieldType <= 12) {
      // Data
      if (
        idFieldFilter === 23 ||
        idFieldFilter === 24 ||
        idFieldFilter === 25
      ) {
        if (fieldType === 5 || fieldType === 7) {
          // Data dd/MM/yyyy
          // Data MM/dd/yyyy

          re = /^\d{2}[\/-]\d{2}[\/-]\d{4}$/
        } else if (fieldType === 6 || fieldType === 8) {
          // Data dd/MM
          // Data MM/dd
          re = /^\d{2}[\/-]\d{2}$/
        } else if (fieldType === 9) {
          // Data yyyyMMdd
          re = /^\d{8}$/
        } else if (fieldType === 10) {
          // Data MMdd
          re = /^\d{4}$/
        } else if (fieldType === 11) {
          // Data yyyy-MM-dd
          re = /^\d{4}[\/-]\d{2}[\/-]\d{2}$/
        }
      } else {
        re = /^[+-]?\d+$/
      }
    } else {
      re = /.*/
    }

    fieldOk = re.test(fieldValue)
  } else {
    fieldOk = fieldValue === ''
  }
  return fieldOk
}

// eslint-disable-next-line no-unused-vars
function validateTrigger(task) {
  let criticalError = false
  const errors = []

  criticalError =
    task === null || task.Detail === null || task.Frequency === null

  if (!criticalError) {
    //  condizione nel caso di dropdown filtri vuoti e si seleziona una condizione di filtro
    let emptyIdFilter = false
    if (task.Detail.ApplyConditionsFilter) {
      task.Detail.ApplyConditions.Filter.forEach(function (element) {
        if (!element.IdFilter) {
          emptyIdFilter = true
        }
      })
    }

    criticalError =
      isEmpty(task.CustomerTimeZone) ||
      (task.Detail.ApplyConditionsFilter &&
        isEmptyArray(task.Detail.ApplyConditions.Filter)) ||
      (task.Detail.FiltersCondition &&
        (isEmptyArray(task.Detail.FilterConditions) ||
          isEmpty(task.Detail.FilterConditionsRules))) ||
      (task.Detail.GroupsCondition &&
        isEmptyArray(task.Detail.GroupConditions)) ||
      isEmpty(task.Frequency.StartHour) ||
      task.Frequency.DailyFrequency < 0 ||
      (task.Frequency.KindDateFrequency.toLowerCase() !== 'd' &&
        task.Frequency.KindDateFrequency.toLowerCase() !== 'w' &&
        task.Frequency.KindDateFrequency.toLowerCase() !== 'm' &&
        task.Frequency.KindDateFrequency.toLowerCase() !== 'y')

    // -- TRIGGER ----------------------------------
    if (isEmpty(task.Name)) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.NameNotSpecified'
        })
      )
    }

    if (isEmpty(task.StartDate)) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.StartDateNotSpecified'
        })
      )
    }

    // -- TRIGGER.DETAIL ----------------------------
    if (
      !task.Detail.ApplyConditionsEvent &&
      !task.Detail.ApplyConditionsField &&
      !task.Detail.ApplyConditionsFilter &&
      !task.Detail.FiltersCondition &&
      !task.Detail.GroupsCondition
    ) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.ConditionNotSpecified'
        })
      )
    }

    if (task.Detail.ApplyConditionsFilter && emptyIdFilter) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.WrongFilterCondition'
        })
      )
    }

    if (
      task.Detail.ApplyConditionsEvent &&
      (task.Detail.ApplyConditions.Event == null ||
        task.Detail.ApplyConditions.Event.DaysFromLastEvent < 0 ||
        task.Detail.ApplyConditions.Event.IdEventFilter <= 0)
    ) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.WrongEventCondition'
        })
      )
    }

    if (
      task.Detail.ApplyConditionsField &&
      (task.Detail.ApplyConditions.Field == null ||
        task.Detail.ApplyConditions.Field.IdField <= 0 ||
        task.Detail.ApplyConditions.Field.IdFieldFilter <= 0 ||
        (fieldFilterNeedsValue(
          task.Detail.ApplyConditions.Field.IdFieldFilter
        ) &&
          isEmpty(task.Detail.ApplyConditions.Field.FieldValue)) ||
        !fieldFilterValueOk(
          task.Detail.ApplyConditions.Field.FieldType,
          task.Detail.ApplyConditions.Field.IdFieldFilter,
          task.Detail.ApplyConditions.Field.FieldValue
        ) ||
        task.Detail.ApplyConditions.Field.FieldType < 0)
    ) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.WrongFieldCondition'
        })
      )
    }

    if (
      (task.Detail.Action === 0 || task.Detail.Action === 1) &&
      task.Detail.IdMessage <= 0
    ) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.NoMessageSelected'
        })
      )
    }

    if (
      task.Detail.Action === -1 &&
      task.Detail.FromGroup === -1 &&
      task.Detail.ToGroup === 0
    ) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.TriggerDoNothing'
        })
      )
    }

    // -- TRIGGER.FEEQUENCY ---------------------------
    if (task.Frequency.DateFrequency <= 0) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.WrongDateFrequency'
        })
      )
    }

    if (
      task.Frequency.KindDateFrequency.toLowerCase() === 'w' &&
      isEmptyArray(task.Frequency.ChoosenDays)
    ) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.WrongWeeklyFrequencyData'
        })
      )
    }

    if (!isEmpty(task.Frequency.Url) && task.Frequency.UrlFrequency <= 0) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.WrongRssUrlFrequency'
        })
      )
    }

    if (
      !isEmptyArray(task.Frequency.BlackoutHours) &&
      task.Frequency.BlackoutHours[0].StartHour >=
        task.Frequency.BlackoutHours[0].EndHour
    ) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.WrongBlackoutHours'
        })
      )
    }

    // -----------------------------------------------
    if (task.Detail.IdFieldUTCCode > 0 && task.Frequency.DailyFrequency > 0) {
      errors.push(
        getIntl.formatMessage({
          id: 'Load.TriggersValidation.MultiplePostsInADayNotPossibleWithRecipientTimeZoneCondition'
        })
      )
    }

    // if (
    //   $scope.tmp.actionIdFieldsEmailSender.idFieldSenderNameMail <= 0 &&
    //   $scope.tmp.actionIdFieldsEmailSender.enabled &&
    //   !$scope.isListPecPlus
    // ) {
    //   errors.push($translate('Load.TriggersValidation.DynamicSenderName'))
    // }

    // if (
    //   $scope.tmp.actionIdFieldsEmailSender.idFieldSenderMail <= 0 &&
    //   $scope.tmp.actionIdFieldsEmailSender.enabled &&
    //   !$scope.isListPecPlus
    // ) {
    //   errors.push($translate('Load.TriggersValidation.DynamicSenderEmail'))
    // }
  }

  if (criticalError) {
    errors.push(
      getIntl.formatMessage({ id: 'Load.TriggersValidation.CriticalError' })
    )
  }

  if (errors.length > 0) {
    toastShow(errors, TOAST_VARIANT_ERROR, 'validation')
    return false
  } else {
    return true
  }
}

export async function simulate(idTask) {
  const result = beAutomationApiSimulate(idTask)
  return result
}

export async function simulateAsync(idTask) {
  const result = beAsyncTaskGetTaskDetails(idTask)
  return result
}
